import {EventEmitter, inject, Injectable} from '@angular/core';
import {IonModal, MenuController, ModalController, ToastController} from '@ionic/angular';
import {AlertController} from '@ionic/angular';
import {HelperService} from './helper.service';
import {LoadingController} from '@ionic/angular';
import {File} from 'app/entities/file.entity';
import {ModalOptions} from '@ionic/core';
import {SwitchItem} from '../entities/switch.entity';
import {SelectModalComponent} from '../components/shared/selectModal/item';
import {SearchModelService} from '../core/search.interface';
import {ConfirmModalComponent} from '../components/shared/confirmModal/item';
import {GalleryModalComponent} from '../components/shared/galleryModal/item';
import {SwitchCheckboxCollection, SwitchRadioCollection} from '../entities/switchCollection.entity';
import {DropDownMenuComponent} from '../components/shared/dropDownMenuModal/item';
import {FilterModalComponent} from 'app/components/shared/filterModal/item';
import {FilterList} from 'app/entities/filter.entity';
import {BlocksModalComponent} from 'app/components/shared/blocksModal/item';
import {BlockSkeletonType} from 'app/entities/enums';
import {DateModalComponent} from 'app/components/shared/dateModal/item';
import {ChatInputFieldComponent} from 'app/components/ui/chat/chat-input-field/item';
import {ChatService} from 'app/services/chat.service';
import {MediaUploadModalComponent} from 'app/components/shared/mediaUploadModal/item';
import {ChatActionModalComponent} from 'app/components/shared/chatModal/components/chatActionModal/item';
import {MessageContent} from '../../../chat-sdk/src/entities/messages/messageContent';
import {Message} from '../../../chat-sdk/src/entities/messages/message';

@Injectable({
  providedIn: 'root',
})
export class AppModalService {

  modalController: ModalController;
  modalOpening = false;
  submenuShow = false;
  indicatorDataUpdated = false;
  keyboardModal: HTMLIonModalElement = null;
  chatService = inject(ChatService);
  // modalInst: HTMLIonModalElement[] = [];
  modalIncr = 0;

  constructor(
    modalController: ModalController
  ) {
    this.modalController = modalController;
  }

  getModalSize(size: string) {
    const map = {
      small: 0.25,
      half: 0.5,
      big: 0.75,
      full: 0.95,
    };

    return map[size];
  }

  async openBlocksModal(blocksGetMethod: any = null, blocksData: any = null, skeletonType: BlockSkeletonType = 'default', callback: (data: any) => void = null) {
    await this.openModal(
      BlocksModalComponent,
      {blocksGetMethod, data: blocksData},
      'full', 'full', (data) => {
        if (callback) {
          callback(data);
        }
      }
    );
  }

  async openModal(
    component,
    data = null,
    maxSize: 'small' | 'half' | 'big' | 'full' = 'full',
    initialSize: 'small' | 'half' | 'big' | 'full' = 'full',
    callback: (data: any) => void = null) {

    const breakpoints = [0];

    // @TODO rework to something smart
    if (maxSize === 'small') {
      breakpoints.push(this.getModalSize('small'));
    }

    if (maxSize === 'half') {
      breakpoints.push(this.getModalSize('small'));
      breakpoints.push(this.getModalSize('half'));
    }

    if (maxSize === 'big') {
      breakpoints.push(this.getModalSize('small'));
      breakpoints.push(this.getModalSize('half'));
      breakpoints.push(this.getModalSize('big'));
    }

    if (maxSize === 'full') {
      breakpoints.push(this.getModalSize('small'));
      breakpoints.push(this.getModalSize('half'));
      breakpoints.push(this.getModalSize('big'));
      breakpoints.push(this.getModalSize('full'));
    }

    // for (let i = 0.01; i <= 0.95; i += 0.05) {
    //   breakpoints.push(i);
    // }
    //
    // console.log(breakpoints);

    const initialBreakpoint = this.getModalSize(initialSize);

    return await this.makeOpenModal({
      component,
      componentProps: data,
      cssClass: `modal-max-size-${maxSize}`,
      // presentingElement: document.querySelector('.ion-page'),
      initialBreakpoint,
      breakpoints,
      mode: 'md'
    }, callback);

  }

  // @todo SAKURA-115 сделать передачу свойств через обьект
  async openGalleryModal(files: File[], initialIndex = 0, cleanMode = false) {
    return await this.makeOpenModal({
      component: GalleryModalComponent,
      componentProps: {
        files,
        activeIndex: initialIndex,
        cleanMode
      },
      cssClass: `modal-gallery`,
      mode: 'md'
    });
  }

  async openQuickSelectModal(options = [], configuration: Partial<SelectModalComponent> = {}) {

    const collection = new SwitchRadioCollection(options.map((item, index) => ({
      id: index,
      title: item.title,
      color: item.color || null,
      icon: item.icon || null,
      data: item.callback
    })));

    configuration.hideItemMark = true;

    this.openSelectModal(collection, configuration, (selectedCollection: SwitchRadioCollection) => {
      selectedCollection?.getSelectedItem()?.data();
    });

  }

  async openSelectModal(
    collection: SwitchCheckboxCollection | SwitchRadioCollection = null,
    configuration: Partial<SelectModalComponent> = null,
    callback: (collection: SwitchCheckboxCollection | SwitchRadioCollection) => void
  ) {

    // TODO bug: вот здесь происходит ошибка (в айтеме "красный" с айдишником не-строкой параметр selected: true, а
    //  после мапа параметр selected становится false)

    if (collection) {
      const items = collection?.items.map(object => ({...object}));

      // TODO придумать что то поэлегантней
      if (collection instanceof SwitchCheckboxCollection) {
        configuration.collection = new SwitchCheckboxCollection(items);
        configuration.collection.convertSelectModalData();
      } else {
        configuration.collection = new SwitchRadioCollection(items);
      }
    }

    return await this.makeOpenModal({
      component: SelectModalComponent,
      componentProps: configuration,
      cssClass: `modal-select`,
      mode: 'md'
    }, (answer) => {
      callback(answer?.collection);
    });
  }

  async openDatePickerModal(data, callback: (data: any) => void = null) {
    return await this.makeOpenModal({
      component: DateModalComponent,
      componentProps: data,
      showBackdrop: true,
      cssClass: `modal-select`,
      mode: 'md',
    }, callback);
  }

  async openAvatarModal(component, data, callback: (data: any) => void = null) {
    return await this.makeOpenModal({
      component,
      componentProps: data,
      cssClass: `modal-select`,
      mode: 'md',
    }, callback);
  }

  async openConfirmModal(data, callback: (answer: boolean) => void) {
    return await this.makeOpenModal({
      component: ConfirmModalComponent,
      showBackdrop: true,
      componentProps: data,
      cssClass: `modal-select`,
      mode: 'md'
    }, (answer) => {
      callback(answer?.answer);
    });
  }

  async openDropDownMenuModal(data, callback: (answer: boolean) => void) {
    this.submenuShow = true;
    return await this.makeOpenModal({
      component: DropDownMenuComponent,
      showBackdrop: true,
      componentProps: data,
      cssClass: `modal-drop-down-menu`,
      mode: 'md'
    }, (answer) => {
      callback(answer?.answer);
    });
  }

  async openFilterModal(data: { filterData: FilterList; search: boolean; title?: string }, callback: (data: any) => void) {
    return await this.openModal(FilterModalComponent, data, 'full', 'full', callback);
  }

  async makeOpenModal(options: ModalOptions, callback: (data) => void = null) {

    if (this.modalOpening) {
      return null;
    }

    this.modalOpening = true;
    const modal = await this.modalController.create(options);

    await modal.present();

    this.modalOpening = false;

    if (!window.history.state.modal) {
      const modalState = {modal: true};
      history.pushState(modalState, null);
    }

    // this.storeModal(modal);

    await modal.onDidDismiss().then((res) => {
      this.submenuShow = false;
      if (/*res.data && */callback) {
        callback(res.data);
      }
    });

    return modal;
  }

  async preloadModals(components: unknown[] = []) {
    for (const component of components) {
      await this.preloadModal(component);
    }
  }

  async preloadModal(component, data = {}) {
    const tempModal = await this.modalController.create({
      animated: false, // this should prevent it from being visible
      swipeToClose: false, // disable interaction to prevent unexpected behavior
      backdropDismiss: false, // disable interaction to prevent unexpected behavior
      showBackdrop: false, // minimize changes to UI
      keyboardClose: false, // minimize side-effects
      component, // Your custom modal component likely won't render, be sure to preload any related assets inside the index.html <head> tags
      componentProps: data,
      cssClass: 'hide'
    });
    await tempModal.present();
    await tempModal.dismiss();
  }

  async closeTopModal() {
    try {
      const element = await this.modalController.getTop();
      if (element) {
        element.dismiss();
        this.submenuShow = false;
        return;
      }
    } catch (error) {
      console.log(error);
    }
  }

  // storeModal(m: any) {
  //   this.modalInst[this.modalIncr] = m;
  //   this.modalIncr++;
  // }

  async openKeyboardModal(messageSendCallback: (content: Partial<MessageContent>) => void, onReady: (chatInput: ChatInputFieldComponent) => void) {
    this.keyboardModal = await this.modalController.create({
      id: 'keyboard-modal',
      componentProps: {messageSendCallback, onReady},
      initialBreakpoint: 1,
      breakpoints: [0, 1],
      backdropDismiss: false,
      backdropBreakpoint: 1,
      component: ChatInputFieldComponent,
      cssClass: 'keyboard-modal',
      handle: false,
    });
    // this.keyboardModal.classList.add('keyboard-modal');
    // this.storeModal(this.keyboardModal);
    await this.keyboardModal.present();

    return this.keyboardModal;
  }

  closeKeyboardModal() {
    if (this.keyboardModal) {
      this.keyboardModal.dismiss();
    }
  }

  async openMediaUploadModal(
    configuration: Partial<MediaUploadModalComponent> = null,
    callback: (data: any) => void
  ) {
    return await this.makeOpenModal({
      component: MediaUploadModalComponent,
      componentProps: configuration,
      cssClass: `modal-select file-select-modal`,
      mode: 'md'
    }, (answer) => {
      callback(answer?.answer);
    });
  }

  async openChatActionModal(message: Message, callback: (data: any) => void) {
    return await this.makeOpenModal({
      componentProps: {message},
      component: ChatActionModalComponent,
      cssClass: `modal-select chat-action-modal`,
      mode: 'md'
    }, (answer) => {
      callback(answer);
    });
  }
}
